<template>
  <div class="search-detaile m-t-40">
    <v-container>
      <div class="position">
        <div class="bg-white p-20">
          <div
            id="searchFilter"
            class="search-head collapse-content"
          >
            <div>
              <v-row>
                <v-col cols md="8">
                  <label>{{ $t('Поиск по названию, тексту, ID проекта') }}</label>
                  <v-text-field
                    v-model="search.name"
                    :aria-label="$t('Поиск по названию, тексту, ID проекта')"
                    required
                    outlined
                    dense
                    clearable
                    :placeholder='$t("Введите текст")'
                  />
                </v-col>
                <v-col cols md="4" v-show="showSearchFilter">
                  <label>{{ $t('Редакция') }}</label>
                  <div class="select-def">
                    <v-select
                      :items="data.refNpaEdition"
                      item-value="id"
                      item-text="transName"
                      v-model="search.edition"
                      :aria-label="$t('Редакция')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row v-show="showSearchFilter">
                <v-col cols md="4">
                  <label>{{ $t('Вид проекта НПА') }}</label>
                  <div class="select-def">
                    <v-select
                      :items="data.refNpaView"
                      item-value="id"
                      item-text="transName"
                      v-model="search.view"
                      :aria-label="$t('Вид проекта НПА')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
                <v-col cols md="4" v-if="data.npaViewLocalResolution && search.view == data.npaViewLocalResolution.id">
                  <label>{{ $t('Область') }}</label>
                  <div class="select-def">
                    <v-select
                      :items="data.refRegions"
                      return-object
                      item-text="transName"
                      v-model="region"
                      :aria-label="$t('Область')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
                <v-col cols md="4" v-if="data.npaViewLocalResolution && search.view == data.npaViewLocalResolution.id">
                  <label>{{ $t('Район') }}</label>
                  <div class="select-def">
                    <v-select
                      v-if="region"
                      :items="region.districts"
                      item-value="id"
                      item-text="transName"
                      v-model="search.district"
                      :aria-label="$t('Район')"
                      required
                      outlined
                      dense
                    />
                    <v-select
                      v-else
                      placeholder="Выберите область"
                      :aria-label="$t('Район')"
                      disabled
                      outlined
                      dense
                    />
                  </div>
                </v-col>

                <v-col cols md="4">
                  <label>{{ $t('Разработчик проекта НПА') }}</label>
                  <div class="select-def">
                    <v-autocomplete
                      :items="data.refDeveloper"
                      item-value="id"
                      item-text="transName"
                      v-model="search.developer"
                      :aria-label="$t('Разработчик проекта НПА')"
                      required
                      outlined
                      dense
                      clearable
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-icon class="select-def__icon">
                          <v-icon :class="item.status === false ? 'nv_icon' : ''" x-small/>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.transName }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols md="4">
                  <label>{{ $t('Инициатор проекта НПА') }}</label>
                  <div class="select-def">
                    <v-select
                      :items="data.refInitiator"
                      item-value="id"
                      item-text="transName"
                      v-model="search.initiator"
                      :aria-label="$t('Инициатор проекта НПА')"
                      required
                      outlined
                      dense
                      clearable
                    />
                  </div>
                </v-col>
              </v-row>
              <v-row v-show="showSearchFilter">
                <v-col cols md="4">
                  <label>{{ $t('Категории') }}</label>
                  <div class="select-def">
                    <v-autocomplete
                      v-model="search.category"
                      item-value="id"
                      :items="data.refCategory"
                      item-text="transName"
                      :aria-label="$t('Категории')"
                      multiple
                      deletable-chips
                      outlined
                      dense
                      :search-input.sync="searchCategory"
                      @change="searchCategory = ''"
                      clearable
                    />
                  </div>
                </v-col>
                <v-col cols md="4">
                  <label>{{ $t('Период обсуждения проекта НПА') }}</label>
                  <v-row>
                    <v-col cols md="6" class="date">
                      <v-menu
                        v-model="search.menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="search.discussionPeriodDateFrom"
                            :aria-label="$t('Период обсуждения проекта НПА') + ': ' + $t('с')"
                            readonly
                            v-on="on"
                            outlined
                            dense
                            clearable
                          />
                        </template>
                        <v-date-picker
                          v-model="search.discussionPeriodDateFrom"
                          :weekday-format="getDay"
                          :month-format="getMonthFormat"
                          :header-date-format="getHeaderDateFormat"
                          no-title
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </v-col>
                    <v-col cols md="6" class="date">
                      <v-menu
                        v-model="search.menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="search.discussionPeriodDateTo"
                            :aria-label="$t('Период обсуждения проекта НПА') + ': ' + $t('по')"
                            readonly
                            v-on="on"
                            outlined
                            dense
                            clearable
                          />
                        </template>
                        <v-date-picker
                          v-model="search.discussionPeriodDateTo"
                          :weekday-format="getDay"
                          :month-format="getMonthFormat"
                          :header-date-format="getHeaderDateFormat"
                          no-title
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols md="4" class="date">
                  <label>{{ $t('Дата размещения проекта НПА') }}</label>
                  <v-menu
                    v-model="search.menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.publishDate"
                        :aria-label="$t('Дата размещения проекта НПА')"
                        readonly
                        v-on="on"
                        outlined
                        dense
                        clearable
                      />
                    </template>
                    <v-date-picker
                      v-model="search.publishDate"
                      :weekday-format="getDay"
                      :month-format="getMonthFormat"
                      :header-date-format="getHeaderDateFormat"
                      no-title
                      first-day-of-week="1"
                    />
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-show="showSearchFilter">
                <v-col cols md="4">
                  <label>{{ $t('Статус проекта') }}</label>
                  <v-select
                    :items="data.refStatus"
                    item-value="id"
                    item-text="transName"
                    v-model="search.status"
                    :aria-label="$t('Статус проекта')"
                    required
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <v-col cols md="4">
                  <label>{{ $t('Дополнительный фильтр') }}</label>
                  <v-select
                    outlined
                    dense
                    :items="advancedOptions"
                    v-model="search.advanced"
                    :aria-label="$t('Дополнительный фильтр')"
                    clearable
                  />
                </v-col>
                <v-col cols md="4" v-if="search.advanced && search.advanced === $t('Последние размещенные проекты')">
                  <label>{{ $t('За период') }}</label>
                  <v-select
                    outlined
                    dense
                    item-value="id"
                    item-text="value"
                    :items="periods"
                    v-model="search.period"
                    :aria-label="$t('За период')"
                    clearable
                  />
                </v-col>
                <v-col cols md="4">
                  <label>{{ $t('Поиск по ключевым словам') }}</label>
                  <KeywordSearch
                    v-if="data.refKeyword != undefined"
                    v-model="search.keyword"
                    :search-data="data.refKeyword"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="search-body">
            <div class="search-action">
              <div>
                <v-row>
                  <v-col cols sm="12" md>
                    <a
                      href="#"
                      class="btn-column-list"
                      :aria-label="showBlock ? $t('Показать списком') : $t('Показать плиткой')"
                      @click.prevent="showBlock = !showBlock"
                    >
                      <v-icon x-large v-if="showBlock" aria-hidden="true">mdi-view-list</v-icon>
                      <v-icon x-large v-else aria-hidden="true">mdi-view-module</v-icon>
                    </a>
                  </v-col>
                  <v-col class="form-action" cols sm="12" md>
                    <button
                      class="btn btn-default blue"
                      @click=";(page = 1), searchNPA()"
                    >
                      {{ $t('Поиск') }}
                    </button>
                    <button
                      class="btn btn-default green white--text ml-2"
                      @click="exportToExcel"
                      :disabled="isLoadingExcel"
                    >
                      <v-icon left x-small>mdi-file-excel</v-icon>
                      {{ $t('Excel') }}
                    </button>
                    <button
                      class="btn btn-default white"
                      @click="resetSearchNPA()"
                    >
                      {{ $t('Очистить') }}
                    </button>
                  </v-col>
                  <v-col class="text-right" cols sm="12" md>
                    <a
                      href="#"
                      class="btn-collapse"
                      :aria-expanded="showSearchFilter ? 'true' : 'false'"
                      @click.prevent="showSearchFilter = !showSearchFilter"
                    >
                      <span v-if="showSearchFilter">{{ $t('Свернуть') }}</span>
                      <span v-else>{{ $t('Показать') }}</span> {{ $t('расширенный фильтр') }}
                    </a>
                  </v-col>
                </v-row>
              </div>
            </div>
            <div class="search-result">
              <div>
                <div class="search-result-head">
                  <label>
                    {{ $t('Быстрые фильтры') }}:
                    <a href="#" @click.prevent="quickSearch('Most talked')">{{ $t('Наиболее обсуждаемые') }}</a>
                    <a href="#" @click.prevent="quickSearch('Discussion ends today')">{{
                        $t('Обсуждение заканчивается сегодня')
                      }}</a>
                  </label>
                </div>

                <div class="search-result-body">
                  <mq-layout mq="laptop">
                    <div class="type-column">
                      <v-simple-table v-if="!showBlock">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <td
                                v-for="(item, index) in headerTable"
                                :key="index"
                              >
                                <Sorting
                                  v-if="item.sorting"
                                  :item="item"
                                  :filterable="item.filterable"
                                  :currentOrderKey="orderBy"
                                  @order="sortData($event)"
                                  @filter="sortingFilterHandler($event)"
                                  @cancelSorting="cancelSorting()"
                                />
                                <span v-else>
                                  {{ item.name }}
                                </span>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in result" :key="item.id">
                            <td>{{ item.view.transName }}</td>
                            <td>
                              <router-link
                                :title="item.transProjectGoal | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })"
                                :key="item.id"
                              >
                                {{ item.transName }}
                              </router-link>
                            </td>
                            <td>
                              <div class="analytics">
                                <span class="views">
                                  <i class="pro-icon-eye" aria-hidden="true"></i>
                                  <span class="sr-only">{{ $t('Просмотры') }}: </span>
                                  {{ item.view_number }}
                                </span>
                                <span class="comments">
                                  <i class="pro-icon-chat" aria-hidden="true"></i>
                                  <span class="sr-only">{{ $t('Комментарии') }}: </span>
                                  {{ commentsCnt[item.id].cntComments }}
                                </span>
                                <span class="messages">
                                  <i class="pro-icon-speech-bubble" aria-hidden="true"></i>
                                  <span class="sr-only">{{ $t('Ответы') }}: </span>
                                  {{ answersCnt[item.id].cntAnswers }}
                                </span>
                              </div>
                            </td>
                            <td>
                              <v-card
                                class="d-flex align-start bg-transparent"
                              >
                                <v-icon
                                  v-if="item.developer.status === false"
                                  class="nv_icon mt-1 mr-1"
                                  x-small
                                />
                                <div>{{ item.developer.transName }}</div>
                              </v-card>
                            </td>
                            <td>
                              <template v-for="(category, i) in item.category">
                                <span :key="category.id">
                                  {{ category.transName }}
                                  <span v-if="i+1 != item.category.length">, </span>
                                </span>
                              </template>
                            </td>
                            <td>
                              {{
                                new Date(item.publish_date)
                                  | dateFormat('DD.MM.YYYY')
                              }}
                            </td>
                            <td>{{ item.status.transName }}
                              <div v-if="item.status.id === 9">
                                {{
                                  new Date(item.lastNpaHistory.date_accept)
                                    | dateFormat('DD.MM.YYYY')
                                }}
                                {{ item.lastNpaHistory.comment }}
                              </div>
                            </td>
                            <td>
                              {{
                                new Date(item.discussion_period_date_to)
                                  | dateFormat('DD.MM.YYYY')
                              }}
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <div class="columns-item" v-else>
                        <v-row>
                          <v-col cols md="4" v-for="item in result" :key="item.id">
                            <div class="project-type">{{ item.view.transName }}</div>
                            <div class="npa-title">
                              <router-link
                                :title="item.transProjectGoal | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })"
                                :key="item.id"
                              >
                                {{ item.transName | splitTextIntoLines(4, 30) }}
                              </router-link>
                            </div>
                            <div class="npa-dev">
                              <v-card
                                class="d-flex align-start bg-transparent"
                              >
                                <v-icon
                                  v-if="item.developer.status === false"
                                  class="nv_icon mt-1 mr-1"
                                  x-small
                                />
                                <div>{{ item.developer.transName | splitTextIntoLines(2, 30) }}</div>
                              </v-card>
                            </div>
                            <div class="date-period">
                              <p>{{ item.status.transName }}</p>
                              <p>
                                {{ $t('Дата окончания обсуждения') }}:
                                {{
                                  new Date(item.discussion_period_date_to)
                                    | dateFormat('DD.MM.YYYY')
                                }}
                              </p>
                            </div>
                            <div class="npa-analitics">
                              <div class="analytics">
                              <span class="views">
                                <i class="pro-icon-eye" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('Просмотры') }}: </span>
                                {{ item.view_number }}
                              </span>
                                <span class="comments">
                                <i class="pro-icon-chat" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('Комментарии') }}: </span>
                                {{ commentsCnt[item.id].cntComments }}
                              </span>
                                <span class="messages">
                                <i class="pro-icon-speech-bubble" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('Ответы') }}: </span>
                                {{ answersCnt[item.id].cntAnswers }}
                              </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </mq-layout>
                  <mq-layout mq="mobile">
                    <div class="type-column">
                      <div class="columns-item">
                        <v-row>
                          <v-col cols md="4" v-for="item in result" :key="item.id">
                            <div class="project-type">{{ item.view.transName }}</div>
                            <div class="npa-title">
                              <router-link
                                :title="item.transProjectGoal | strippedContent"
                                active-class="active"
                                :to="$i18nRoute({ name: 'view-npa', params: { id: item.id } })"
                                :key="item.id"
                              >
                                {{ item.transName | splitTextIntoLines(4, 30) }}
                              </router-link>
                            </div>
                            <div class="npa-dev">
                              <a href="#!">{{ item.developer.transName | splitTextIntoLines(2, 30) }}</a>
                            </div>
                            <div class="date-period">
                              <p>{{ item.status.transName }}</p>
                              <p>
                                {{ $t('Дата окончания обсуждения') }}:
                                {{
                                  new Date(item.discussion_period_date_to)
                                    | dateFormat('DD.MM.YYYY')
                                }}
                              </p>
                            </div>
                            <div class="npa-analitics">
                              <div class="analytics">
                              <span class="views">
                                <i class="pro-icon-eye" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('Просмотры') }}: </span>
                                {{ item.view_number }}
                              </span>
                                <span class="comments">
                                <i class="pro-icon-chat" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('Комментарии') }}: </span>
                                {{ commentsCnt[item.id].cntComments }}
                              </span>
                                <span class="messages">
                                <i class="pro-icon-speech-bubble" aria-hidden="true"></i>
                                <span class="sr-only">{{ $t('Ответы') }}: </span>
                                {{ answersCnt[item.id].cntAnswers }}
                              </span>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </mq-layout>
                </div>
                <div class="search-result-footer">
                  <p>{{ $t('Общее количество НПА') }}: {{ paginationData.totalCount }}</p>
                </div>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="paginationData.pageCount"
              :aria-label="$t('Страницы результатов поиска')"
              total-visible="15"
            />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import CMS from '@/model/cms'
import Search from '@/model/search'
import {mapGetters, mapMutations} from 'vuex'
import mixin from '@/plugins/mixin/mixin'

/* import components */
import KeywordSearch from '@/components/widget/KeywordSearch.vue'
import Sorting from "@/components/app/Sorting"
import axios from 'axios';
import { Trans } from '@/plugins/Translation'
export default {
  mixins: [mixin],
  components: {
    Sorting,
    KeywordSearch
  },
  data: () => ({
    showSearchFilter: true,
    showBlock: false,
    search: {},
    region: {},
    orderBy: 'publishDate',
    orderDir: 'desc',
    data: [],
    paginationData: {},
    result: [],
    commentsCnt: [],
    answersCnt: [],
    page: 1,
    advancedOptions: [],
    searchKeyword: '',
    searchCategory: '',
    periods: [],
    isLoadingExcel: false,
  }),
  watch: {
    // при изменениях маршрута запрашиваем данные снова
    $route: 'fetchData',
    page() {
      this.searchNPA()
    }
  },
  metaInfo() {
    return {
      title: this.$i18n.t('searchNPATitleSEO'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.$i18n.t('searchNPADescriptionSEO'),
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.$i18n.t('searchNPAKeywordsSEO'),
      }]
    }
  },
  created() {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
  },
  computed: {
    headerTable() {
      const fields = [
        { name: this.$t('Вид проекта'), key: 'view', sorting: true, filterable: true, filterItems: this.data.refNpaView },
        { name: this.$t('Наименование'), key: 'name', sorting: true },
        { name: this.$t('Комментарии'), sorting: true, keys: ['commentsCount', 'viewNumber', 'answersCount'], children: [
            { name: this.$t('Комментарии'), key: 'commentsCount' },
            { name: this.$t('Просмотры'), key: 'viewNumber' },
            { name: this.$t('Ответы'), key: 'answersCount' }
          ]
        },
        { name: this.$t('Разработчик'), key: 'developer', sorting: true, filterable: true, filterItems: this.data.refDeveloper },
        { name: this.$t('Категории'), key: 'category', sorting: true, filterable: true, filterItems: this.data.refCategory},
        { name: this.$t('Дата публикации'), key: 'publishDate', sorting: true },
        { name: this.$t('Статус'), key: 'status', sorting: true, filterable: true, filterItems: this.data.refStatus },
        { name: this.$t('Дата окончания обсуждения'), key: 'discussionPeriodDateTo', sorting: true }
      ]
      return fields
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      CMS.getNpaData().then((response) => {
        this.data = response.data
        this.search = {}
        this.region = {}

        this.advancedOptions = [
          this.$i18n.t('Наиболее посещаемые'),
          this.$i18n.t('Наиболее обсуждаемые'),
          this.$i18n.t('Обсуждение заканчивается сегодня'),
          this.$i18n.t('Требует финансирования'),
          this.$i18n.t('Затрагивает предпринимательскую деятельность'),
          this.$i18n.t('Последние размещенные проекты')
        ]

        this.periods = [
          {
            id: '-1 day',
            value: this.$i18n.t('1 день')
          },
          {
            id: '-1 week',
            value: this.$i18n.t('1 неделя')
          },
          {
            id: '-1 month',
            value: this.$i18n.t('1 месяц')
          },
          {
            id: '-1 year',
            value: this.$i18n.t('1 год')
          },
          {
            id: 'all',
            value: this.$i18n.t('все время')
          }
        ]

        if (this.$route.query.view) {
          this.search.view = parseInt(this.$route.query.view)
        }

        if (this.$route.query.edition) {
          this.search.edition = parseInt(this.$route.query.edition)
        }

        if (this.$route.query.status) {
          this.search.status = parseInt(this.$route.query.status)
        }

        if (this.$route.query.name) {
          this.search.name = this.$route.query.name
        }

        if (this.$route.query.developer) {
          this.search.developer = parseInt(this.$route.query.developer)
        }

        if (this.$route.query.initiator) {
          this.search.initiator = parseInt(this.$route.query.initiator)
        }

        if (this.$route.query.category) {
          let arrCategory = [parseInt(this.$route.query.category)]
          this.search.category = arrCategory
        }

        if (this.$route.query.keyword) {
          let arrKeyword = [parseInt(this.$route.query.keyword)]
          this.search.keyword = arrKeyword
        }

        if (this.$route.query.last == 'npa') {
          this.search.advanced = this.$i18n.t('Последние размещенные проекты')
        }

        if (this.$route.query.publishDateFrom) {
          this.search.publishDateFrom = this.$route.query.publishDateFrom
        }

        if (this.$route.query.publishDateTo) {
          this.search.publishDateTo = this.$route.query.publishDateTo
        }

        if (this.$route.query.period) {
          this.search.period = this.$route.query.period
        }

        if (this.$route.query.hasComments) {
          this.search.hasComments = this.$route.query.hasComments
        }

        if (this.$route.query.hasAnswers) {
          this.search.hasAnswers = this.$route.query.hasAnswers
        }

        if (this.$route.query.hasExpiredAnswers) {
          this.search.hasExpiredAnswers = this.$route.query.hasExpiredAnswers
        }

        if (this.$route.query.hasUnansweredComments) {
          this.search.hasUnansweredComments = this.$route.query.hasUnansweredComments
        }

        this.setLoading(false)
        this.searchNPA()
      })
    },
    searchNPA() {
      this.setLoading(true)
      this.search.page = this.page
      this.search.orderBy = this.orderBy
      this.search.orderDir = this.orderDir
      if (this.region.hasOwnProperty('id')) {
        this.search.region = this.region.id
      }
      if (!this.search.advanced || (this.search.advanced && this.search.advanced !== this.$i18n.t('Последние размещенные проекты'))) {
        delete this.search.period
      }
      Search.search(this.search).then((response) => {
        this.result = response.data.items
        this.paginationData = response.data.paginationData
        this.commentsCnt = response.data.commentsCnt
        this.answersCnt = response.data.answersCnt

        this.setLoading(false)
      })
    },
    resetSearchNPA() {
      this.search = {}
      this.region = {}
      this.$router.replace({query: null})
      this.page = 1
      this.orderBy = 'publishDate'
      this.orderDir = 'desc'
      this.searchKeyword = null
      this.searchNPA()
    },
    sortData(sort) {
      this.orderBy = sort.key
      this.orderDir = sort.value
      this.page = 1
      this.searchNPA()
    },
    quickSearch(str) {
      this.page = 1
      if (str == 'Most talked')
        this.search.advanced = this.$i18n.t('Наиболее обсуждаемые')
      else if (str == 'Discussion ends today')
        this.search.advanced = this.$i18n.t('Обсуждение заканчивается сегодня')
      this.searchNPA()
    },
    sortingFilterHandler(filter) {
      this.search[filter.name] = filter.value
      this.searchNPA()
    },
    cancelSorting () {
      this.orderBy = 'publishDate'
      this.orderDir = 'desc'
      this.searchNPA()
    },
    /**
     * Экспорт в Excel с учетом текущих фильтров
     */
    exportToExcel() {
      this.isLoadingExcel = true;

      // Подготовка параметров для экспорта
      // Копируем текущий объект поиска, чтобы не мутировать оригинал
      const params = { ...this.search };

      // Если выбран регион, добавляем его в параметры
      if (this.region.hasOwnProperty('id')) {
        params.region = this.region.id;
      }

      // Логика удаления периода, если не выбран Advanced фильтр (копия из searchNPA)
      if (!params.advanced || (params.advanced && params.advanced !== this.$i18n.t('Последние размещенные проекты'))) {
        delete params.period;
      }

      // Формируем URL для экспорта
      // Предполагаем, что у вас есть роут на бэкенде /api/public/search/export/excel
      // Если роута нет, его нужно создать в SearchController (см. ниже)
      const url = `${process.env.VUE_APP_BACK_URL}${Trans.currentLocale}/api/public/search/export/excel`;

      axios({
        url: url,
        method: 'GET',
        params: params, // Передаем все фильтры поиска
        responseType: 'blob', // Важно: ожидаем бинарный файл
      })
        .then((response) => {
          // Создаем ссылку для скачивания файла
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;

          // Генерируем имя файла с датой
          const date = new Date().toISOString().slice(0,10);
          link.setAttribute('download', `npa_projects_${date}.xlsx`);

          document.body.appendChild(link);
          link.click();

          // Чистим за собой
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$noty.success(this.$t('Файл успешно сформирован'), {
            killer: true, timeout: 2000, layout: 'topRight'
          });
        })
        .catch((error) => {
          console.error('Export error:', error);
          this.$noty.error(this.$t('Ошибка при экспорте файла'), {
            killer: true, timeout: 2000, layout: 'topRight'
          });
        })
        .finally(() => {
          this.isLoadingExcel = false;
        });
    },
  }
}
</script>
